/// <reference path="../+data/smat-nasa/registration-form/registration-form.module.ts" />
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../shared/services/auth.service';
import { ClientService } from '../shared/services/client.service';
import { LayoutService } from '../shared/layout/layout.service';
import { routing } from "./auth.routing";
import { AuthComponent } from './auth.component';
import { CreateUserComponent } from './+sunrise/create-user/create-user.component';
import { UserComponent } from './+user/user.component';
import { imvoCreateUserComponent } from './+imvo/create-user/create-user.component';
import { nudbCreateUserComponent } from './+smat-nudb/create-user/create-user.component';

import { RegistrationFormModule } from '../+data/smat-nasa/registration-form/registration-form.module';
import { EmployeeSetupModule } from '../shared/dynamic-controls/employee-setup/employee-setup.module';
import { IMVOSession } from 'src/app/+data/imvo-kznc/imvo-kznc.session';
import { nasaCreateUserComponent } from './+smat-nasa/create-user/create-user.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    EmployeeSetupModule,
    RegistrationFormModule,
    routing
  ],
  declarations: [AuthComponent, CreateUserComponent, imvoCreateUserComponent, UserComponent, nudbCreateUserComponent, nasaCreateUserComponent],
    providers: [AuthService, ClientService, LayoutService, IMVOSession]
})
export class AuthModule { }
